import useStore from './use-store';

const useTimezone = () => {

    const { store } = useStore();
    const { server, session } = store;
    const attributesSesssion = session.attributes;
    const attributesServer = server.attributes;
  
    const timezone = attributesSesssion.hasOwnProperty('timezone') ? attributesSesssion.timezone : attributesServer.timezone;

    return {timezone};
};

export default useTimezone;
